import { pdfjs as v } from "react-pdf";
import { pdfjs as ie } from "react-pdf";
import { logger as m } from "@pufflig/logger";
import { shortUID as j, safeStringify as g } from "@pufflig/prompt-tools";
import { fileTypeFromBuffer as S } from "file-type";
import T from "mammoth";
import * as w from "xlsx-republish";
import R, { parse as N } from "papaparse";
const d = 1, u = "/promptbook", c = {
  text: "text/plain",
  pdf: "application/pdf",
  json: "application/json",
  yaml: "application/x-yaml",
  csv: "text/csv",
  parquet: "application/parquet",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  python: "text/x-python",
  js: "text/javascript",
  r: "application/r",
  sql: "application/sql"
}, E = {
  "application/pdf": [".pdf"],
  "application/json": [".json"],
  "application/x-yaml": [".yaml", ".yml"],
  "text/plain": [".txt", ".md", ".csv"],
  "text/html": [".html", ".htm"],
  "text/javascript": [".js", ".jsx", ".ts", ".tsx"],
  "text/css": [".css"],
  "text/x-python": [".py"],
  "text/x-java-source": [".java"],
  "text/x-csrc": [".c"],
  "text/x-c++src": [".cpp"],
  "text/x-csharp": [".cs"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "application/vnd.ms-powerpoint": [".ppt"]
}, f = (e, t) => new Promise((r, o) => {
  const s = indexedDB.open(u, d);
  s.onupgradeneeded = () => {
    const n = s.result;
    n.objectStoreNames.contains("files") || n.createObjectStore("files");
  }, s.onsuccess = () => {
    const a = s.result.transaction("files", "readwrite");
    a.objectStore("files").put(t, e), a.oncomplete = () => {
      r(u + "/files/" + e);
    }, a.onerror = () => {
      console.error("File storage failed"), o(a.error);
    };
  }, s.onerror = function() {
    console.error("IndexedDB error"), o(s.error);
  };
}), P = (e) => new Promise((t, r) => {
  const o = indexedDB.open(u, d);
  o.onupgradeneeded = () => {
    const s = o.result;
    s.objectStoreNames.contains("files") || s.createObjectStore("files");
  }, o.onsuccess = () => {
    const n = o.result.transaction("files", "readwrite");
    n.objectStore("files").delete(e), n.oncomplete = () => {
      t();
    }, n.onerror = () => {
      r(n.error);
    };
  }, o.onerror = () => {
    r(o.error);
  };
}), y = (e) => new Promise((t, r) => {
  const o = indexedDB.open(u, d);
  o.onupgradeneeded = () => {
    const s = o.result;
    s.objectStoreNames.contains("files") || s.createObjectStore("files");
  }, o.onsuccess = () => {
    const n = o.result.transaction("files", "readonly"), i = n.objectStore("files").get(e);
    i.onsuccess = () => {
      const l = i.result;
      t(l);
    }, i.onerror = () => {
      console.error("File retrieval failed"), r(n.error);
    };
  }, o.onerror = () => {
    console.error("IndexedDB error"), r(o.error);
  };
}), x = (e) => new Promise((t, r) => {
  const o = indexedDB.open(u, d);
  o.onupgradeneeded = () => {
    const s = o.result;
    s.objectStoreNames.contains("files") || s.createObjectStore("files");
  }, o.onsuccess = () => {
    const i = o.result.transaction("files", "readonly").objectStore("files").getKey(e);
    i.onsuccess = () => {
      t(i.result !== void 0);
    }, i.onerror = () => {
      t(!1);
    };
  }, o.onerror = () => {
    console.error("IndexedDB error"), r(o.error);
  };
}), re = () => new Promise((e, t) => {
  const r = indexedDB.open(u, d);
  r.onupgradeneeded = () => {
    const o = r.result;
    o.objectStoreNames.contains("files") || o.createObjectStore("files");
  }, r.onsuccess = () => {
    const s = r.result.transaction("files", "readonly"), a = s.objectStore("files").getAllKeys();
    a.onsuccess = () => {
      e(a.result);
    }, a.onerror = () => {
      console.error("File retrieval failed"), t(s.error);
    };
  }, r.onerror = () => {
    console.error("IndexedDB error"), t(r.error);
  };
}), q = (e) => [c.docx, c.xlsx, c.pdf].includes(e.type), D = async (e) => (await T.extractRawText({ arrayBuffer: e })).value, O = (e) => {
  const t = w.read(e, { type: "array" });
  return t.SheetNames.map((r) => {
    const o = t.Sheets[r];
    return w.utils.sheet_to_csv(o);
  }).join(`

`);
}, $ = async (e) => {
  const r = await v.getDocument(new Uint8Array(e)).promise;
  let o = "";
  for (let s = 1; s <= r.numPages; s++) {
    const a = await (await r.getPage(s)).getTextContent();
    let i = -1;
    a.items.forEach((l) => {
      if ("str" in l) {
        const p = l;
        i !== p.transform[5] && (o += `
`, i = p.transform[5]), o += p.str;
      }
    }), o += `

`;
  }
  return o;
}, B = async (e) => {
  const t = await e.arrayBuffer(), r = await S(t), o = r ? r.mime : e.type;
  let s = "", n = o;
  switch (o) {
    case c.pdf:
      s = await $(t);
      break;
    case c.docx:
      s = await D(t);
      break;
    case c.xlsx:
      s = O(t), n = c.csv;
      break;
    default:
      s = new TextDecoder().decode(t);
  }
  return { textContent: s.replace(/\u0000/g, ""), fileType: n };
}, k = (e) => {
  switch (e) {
    case "sql":
      return { fileExt: ".sql", fileType: "text/x-sql" };
    case "python":
      return { fileExt: ".py", fileType: "text/x-python" };
    case "r":
      return { fileExt: ".r", fileType: "text/x-r-script" };
    case "javascript":
      return { fileExt: ".js", fileType: "application/javascript" };
    default:
      return { fileExt: ".txt", fileType: "text/plain" };
  }
}, C = (e) => [c.python, c.js, c.r, c.sql].includes(e), J = (e) => {
  var t;
  return C(e) && ((t = Object.entries(c).find(([r, o]) => o === e)) == null ? void 0 : t[0]) || null;
}, A = (e) => {
  switch (e) {
    case "application/json":
      return "json";
    case "text/markdown":
      return "text";
    case "text/plain":
      return "text";
    case "application/pdf":
      return "text";
    case "text/csv":
      return "table";
    case "application/sql":
      return "code";
    case "application/python":
      return "code";
    case "application/r":
      return "code";
    case "application/javascript":
      return "code";
    default:
      return "text";
  }
}, L = (e) => e.replace(/\.[^/.]+$/, "");
function U(e, t) {
  const r = (/* @__PURE__ */ new Date()).toISOString(), o = A(t.type), s = L(t.name), n = { resourceId: e, createdAt: r, name: s };
  if (o === "code") {
    const a = J(t.type);
    if (!a)
      throw new Error(`Could not determine language for file type ${t.type}`);
    return {
      ...n,
      resourceType: o,
      language: a,
      originalFileName: t.name,
      isReady: !0
    };
  }
  if (o === "table")
    return {
      ...n,
      resourceType: o,
      originalFileName: t.name,
      isReady: !1
    };
  if (o === "text")
    return {
      ...n,
      resourceType: o,
      fileType: t.type,
      originalFileName: t.name,
      isReady: !0
    };
  if (o === "json")
    return {
      ...n,
      resourceType: o,
      originalFileName: t.name,
      isReady: !1
    };
  throw new Error(`Unsupported file type ${t.type}`);
}
const X = () => {
  const e = document.createElement("input");
  return e.type = "file", e.accept = Object.values(E).join(","), e.multiple = !0, new Promise((t, r) => {
    e.onchange = () => {
      try {
        const o = Array.from(e.files ?? []);
        o.length ? t(o) : r(new Error("No files selected"));
      } catch (o) {
        r(o);
      }
    }, e.click();
  });
}, _ = (e) => async (t, r, o = !0) => {
  const s = [], n = [];
  let a = 0;
  for (const i of t || await X()) {
    const l = (r == null ? void 0 : r[a]) || j();
    a++;
    let p = i;
    if (q(i)) {
      const { textContent: h, fileType: b } = await B(i);
      p = new File([h], i.name, { type: b });
    }
    n.push(f(l, p)), o && n.push(e == null ? void 0 : e.saveFile(l, p)), s.push(U(l, p));
  }
  return await Promise.all(n), s;
}, K = (e) => async (t) => {
  if (await x(t))
    return m.debug(`(Storage) Loading file from cache: ${t}`), y(t);
  if (!e)
    throw new Error(`File with id ${t} not found`);
  return m.debug(`(Storage) Loading file from cloud: ${t}`), e == null ? void 0 : e.loadFile(t);
};
function M(e, t) {
  const r = e.originalFileName || e.name || e.resourceId;
  if (e.resourceType === "code") {
    const { fileExt: o, fileType: s } = k(e.language);
    return new File([t], `${r}.${o}`, { type: s });
  }
  if (e.resourceType === "table") {
    const o = R.unparse(JSON.parse(t));
    return new File([o], `${r}.csv`, { type: "text/csv" });
  }
  if (e.resourceType === "text")
    return new File([t], `${r}.md`, { type: "text/markdown" });
  if (e.resourceType === "json")
    return new File([t], `${r}.json`, { type: "application/json" });
  throw new Error(`Unsupported resource type ${e.resourceType}`);
}
const V = (e) => async (t, r, o) => {
  const s = M(t, r), n = [f(t.resourceId, s)];
  e && o && n.push(e.saveFile(t.resourceId, s)), await Promise.all(n);
};
function F(e, t) {
  let r;
  const o = N(e, { header: !0 });
  if (o.data.length > 0 && o.errors.length === 0)
    r = c.csv;
  else
    try {
      const n = JSON.parse(e);
      if (typeof n == "object" && n !== null)
        r = c.json;
      else
        throw new Error("Parsed content is not a complete JSON structure");
    } catch {
      r = c.text;
    }
  return new File([e], t, { type: r });
}
const z = (e) => async (t, r) => {
  const o = F(g(r), t), s = [f(t, o), e == null ? void 0 : e.saveFile(t, o)];
  return await Promise.all(s), { resultId: t, file: o };
}, Y = (e) => async (t) => {
  if (await x(t)) {
    const n = await (await y(t)).text();
    return JSON.parse(n);
  }
  if (!e)
    throw new Error(`File with id ${t} not found`);
  const o = await (await e.loadFile(t)).text();
  return JSON.parse(o);
}, G = (e) => async (t) => {
  await (e == null ? void 0 : e.removeFile(t)), await P(t);
}, H = (e) => async (t, r) => {
  let o;
  if (await x(t)) {
    const l = await (await y(t)).text();
    o = JSON.parse(l);
  } else {
    if (!e) throw new Error(`File with id ${t} not found`);
    const l = await (await e.loadFile(t)).text();
    o = JSON.parse(l);
  }
  const s = { ...o, ...r }, n = F(g(s), t), a = [f(t, n), e == null ? void 0 : e.saveFile(t, n)];
  await Promise.all(a);
}, Q = async (e, t) => {
  const r = [], o = async (s) => {
    if (!await x(s))
      try {
        const n = await (e == null ? void 0 : e.loadFile(s));
        n && await f(s, n);
      } catch (n) {
        console.error(`Error loading file with id ${s}`, n);
      }
  };
  (t || []).forEach((s) => {
    r.push(o(s));
  }), await Promise.all(r);
}, se = async (e, t) => (m.debug(`(Storage) Initializing storage with  defaultFiles: ${JSON.stringify(t, null, 2)}`), e || m.debug("(Storage) No client provided, using local storage only"), await Q(e, t), {
  loadRawFile: K(e),
  loadResult: Y(e),
  removeResult: G(e),
  saveResult: z(e),
  updateResult: H(e),
  uploadFiles: _(e),
  createResource: V(e)
});
export {
  x as fileExists,
  re as getFileIds,
  se as initStorage,
  y as loadFile,
  ie as pdfjs,
  P as removeFile,
  f as saveFile
};
//# sourceMappingURL=index.js.map
